import {
  EnterH5Req,
  EnterH5Rsp,
  IsUserBlockReq,
  IsUserBlockRsp,
  GetGrpNickBatchReq,
  GetGrpNickBatchRsp,
  GetUserInfoBaseReq,
  GetUserInfoBaseRsp,
  GetGroupBotListReq,
  GetGroupBotListRsp,
  GetGrpUserListV3Req,
  GetGrpUserListV3Rsp,
  GetGrpUserInfoBatchReq,
  GetGrpUserInfoBatchRsp,
  GetShanxianH5PopupReq,
  GetShanxianH5PopupRsp,
  UserGender,
  UserStatus,
  UserType,
  CreateUserRsp,
  CreateUserReq,
  GetUserInfoLoginReq,
  GetUserInfoLoginRsp,
  SearchGrpUserRsp,
  SearchGrpUserReq,
} from '../../typings/proto';
import { TRequest } from '../../util/net/typings';
import Net from '../../util/net';
import { COMMON_CHANNEL_ID } from '../../constant/channel';

export default {
  /**
   * 获取用户基础信息
   * @param uidList
   */
  getUserInfoBase(uidList: Array<string>): Promise<GetUserInfoBaseRsp> {
    return Net.request<GetUserInfoBaseRsp, GetUserInfoBaseReq>({
      data: {
        uidList,
      },
      path: 'knockknock.UserBaseSrv/GetUserInfoBase',
    });
  },
  /**
   * 首次进入H5，登录态转换，如果传入gid，会有自动加群逻辑
   * @param gid
   */
  enterH5(gid = ''): Promise<EnterH5Rsp> {
    const data: Record<string, unknown> = {};
    if (gid) {
      data.gid = gid || '';
    }
    return Net.request<EnterH5Rsp, EnterH5Req>({
      data,
      path: 'knockknock.ExternalLoginSrv/EnterH5',
    });
  },
  /**
   * 批量拉取群昵称
   * @param gid
   * @param uidList
   */
  getGrpNickBatch(gid: string, uidList: Array<string>): Promise<GetGrpNickBatchRsp> {
    return Net.request<GetGrpNickBatchRsp, GetGrpNickBatchReq>({
      data: {
        gid,
        uids: uidList,
      },
      path: 'knockknock.GroupMinorSrv/GetGrpNickBatch',
    });
  },
  /**
   * 获取闪现任务完成弹窗
   */
  getSXH5Popup(): Promise<GetShanxianH5PopupRsp> {
    return Net.request<GetShanxianH5PopupRsp, GetShanxianH5PopupReq>({
      path: 'knockknock.ExternalToolboxSrv/GetShanxianH5Popup',
    });
  },
  /**
   * 获取用户禁言状态
   */
  isUserBlock(type: number, uid: string, channelId: string): Promise<IsUserBlockRsp> {
    return Net.request<IsUserBlockRsp, IsUserBlockReq>({
      data: {
        type,
        uid,
        id: channelId,
      },
      path: 'knockknock.GroupMinorSrv/IsUserBlock',
    });
  },
  /**
   * 批量机器人列表信息
   * @param gid 群id
   * @param needBotDetail 只填充机器人id(内部调用) 1:填充机器人详细信息(外部调用需要登录态)
   * @param page 页码
   * @param pageSize 一页数量
   */
  getGroupBotList(
    gid: string,
    needBotDetail: number,
    page: number,
    pageSize: number,
  ): Promise<GetGroupBotListRsp> {
    return Net.request<GetGroupBotListRsp, GetGroupBotListReq>({
      data: {
        gid,
        needBotDetail,
        page: Number(page),
        pageSize: Number(pageSize),
      },
      path: 'knockknock.GroupSrv/GetGroupBotList',
    });
  },
  /**
   * 批量拉取群用户信息
   * @param gid 群id
   * @param uidList 用户列表， 也支持机器人
   * @param bidList 机器人列表
   */
  getGrpUserInfoBatch(
    gid: string,
    uidList: string[],
    bidList?: string[],
  ): Promise<GetGrpUserInfoBatchRsp> {
    const filterUidList = uidList?.filter(uid => !!uid);
    if (!gid || !filterUidList.length) {
      return Promise.reject(new Error(`getGrpUserInfoBatch param error, gid: ${gid}, uidListLength: ${uidList?.length}`));
    }

    return Net.request<GetGrpUserInfoBatchRsp, GetGrpUserInfoBatchReq>({
      data: {
        gid,
        uids: uidList,
        bids: bidList,
      },
      path: 'knockknock.GroupMinorSrv/GetGrpUserInfoBatch',
    });
  },
  /**
   * 获取群用户列表
   * @param gid 群id
   * @param cid 频道id
   * @param pid pageId
   * @param pageSize page大小
   */
  getGrpUserList(
    pageSize: number,
    gid: string,
    cid: string | undefined,
    pid: string | undefined,
  ): Promise<GetGrpUserListV3Rsp> {
    const formatCid: string | undefined = cid === COMMON_CHANNEL_ID ? undefined : cid;
    return Net.request<GetGrpUserListV3Rsp, GetGrpUserListV3Req>({
      path: 'knockknock.GroupUserListSrv/GetGrpUserListV3',
      data: {
        gid,
        pid,
        pageSize,
        cid: formatCid,
      },
    });
  },
  /**
   * 获取搜欧索群用户列表
   * @param gid 群id
   * @param cid 频道id
   * @param pid pageId
   * @param pageSize page大小
   */

  /**
   * 获取根据关键字搜索的群用户列表
   * @param reqParam
   */
  getSearchGrpUserList(reqParam: TRequest<SearchGrpUserReq>): Promise<SearchGrpUserRsp> {
    return Net.request<SearchGrpUserRsp, SearchGrpUserReq>({
      path: 'knockknock.GroupUserListSrv/SearchGrpUser',
      data: reqParam,
    });
  },
  /**
   * 个人信息编辑
   * @param uid 用户id
   * @param gender 性别
   * @param num 手机号
   * @param nickname 昵称
   * @param avatar 头像
   */
  postCreateUser(
    uid: string,
    nickname: string,
    avatar: string,
    gender: UserGender,
    userType: UserType,
    num: string,
    userStatus: UserStatus,
    code: string,
  ): Promise<CreateUserRsp> {
    return Net.request<CreateUserRsp, CreateUserReq>({
      path: 'knockknock.UserBaseSrv/CreateUser',
      data: {
        userInfoBase: {
          uid,
          nickname,
          avatar,
          gender,
          userType,
          num,
          userStatus,
        },
        inviteCode: code,
      },
    });
  },
  getUserInfoLogin(): Promise<GetUserInfoLoginRsp> {
    return Net.request<GetUserInfoLoginRsp, GetUserInfoLoginReq>({
      path: 'knockknock.UserBaseSrv/GetUserInfoLogin',
      data: {},
    });
  },
};
